import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import { router } from "@/router/index";

export { queryClient };

type AppProvidersProps = {
  queryClient?: QueryClient;
  router?: typeof router;
};

export function AppProviders({
  queryClient: client = queryClient,
  router: appRouter = router,
}: AppProvidersProps = {}) {
  return (
    <QueryClientProvider client={client}>
      <RouterProvider router={appRouter} />
    </QueryClientProvider>
  );
}
